<template>
    <div class="wrapper menu_wrapper" :class="menu_wrapper_class" @click="toggle_menu_wrapper">
        <div class="container">
<!--            <div class="logo_container"><a :href="logo_link" v-if="logo_link"></a></div>-->
            <div class="menu_container">
                <div class="menu_trigger" @click="toggle_menu"></div>
                <div class="menu_item" v-for="menu_item in menu_items" :key="menu_item.id" :class="{active: is_active(menu_item) }" v-if="show_menu_item(menu_item)">
                    <a href="javascript:void(0)" @click="set_active(menu_item)"><span v-html="menu_item.display_name"></span></a>
                    <div class="sub_menu_container" v-if="menu_item._ref_list_children">
                        <div class="sub_menu_item" v-for="sub_menu_item in menu_item._ref_list_children" :key="sub_menu_item.id" :class="{active: is_active(sub_menu_item) }">
                            <a href="javascript:void(0)" @click="set_active(sub_menu_item)"><span v-html="sub_menu_item.display_name"></span></a>
                        </div>
                    </div>
                </div>
<!--                <div class="menu_item" style="margin-left: auto;" v-if="$root.panel === 'admin'">-->
<!--                    <a class="btn btn-primary" target="_blank" style="font-size: 1em;" href="https://integrations.staging.bgl360.com.au/u/oauth/authorize?response_type=code&client_id=ee59a6df-8f88-4d9f-b3ba-7a2cf48d237b&scope=cas_incorporator&redirect_uri=https://www.macquariegs.com.au/bgl/callback">Connect BGL API</a>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TopMenu',
        props: ['menu_items','current_page_id','root_menu_list'],
        data() {
            return {
                menu_wrapper_class:(this.$root.panel?this.$root.panel:'general')+'_menu_wrapper',
                // menu_wrapper_class:'front_menu_wrapper',
                // logo_link:(typeof this.$root.logo_link === 'undefined')?'/':this.$root.logo_link
            }
        },
        // computed: {
        //     logo_link: function () {
        //         if (typeof this.$root.logo_link !== 'undefined') {
        //             return this.$root.logo_link;
        //         }
        //         return '/';
        //     }
        // },
        methods: {
            show_menu_item: function (menu_item) {
                if (this.root_menu_list) {
                    if (this.root_menu_list.indexOf(menu_item.id) !== -1) {
                        return true;
                    } else {
                        return false;
                    }
                }
                return true;
            },
            set_active: function (menu_item) {
                if (!menu_item.page_id && menu_item.description) {
                    location.replace(menu_item.description);
                }
                this.$root.set_page(menu_item.page_id);
            },
            is_active: function (menu_item) {
                if (menu_item.page_id === this.current_page_id) {
                    return true;
                }
                if (menu_item._ref_list_children && menu_item._ref_list_children.length) {
                    for (let i=0;i<menu_item._ref_list_children.length;i++) {
                        if (this.is_active(menu_item._ref_list_children[i])) {
                            return true;
                        }
                    }
                }
                return false;
            },
            toggle_menu: function (event) {
                $('body').toggleClass('mobile_menu_open')
            },
            toggle_menu_wrapper: function (event) {
                if ($(event.target).hasClass('menu_wrapper')) {
                    $('body').toggleClass('mobile_menu_open')
                }
            }
        }
    }
</script>